export enum AspectAbord {
    Propre = 1,
    Sale = 2
}
